import React from "react";
import "./GridSection.scss";

const GridSection = (props) => (
  <section className={`section-grid theme-${props.theme} ${props.className}`}>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2>{props.title}</h2>
        </div>
        <div className="item col-12">
          {props.grids.map((grid, index) => (
            <div className="row group">
              <h5>{grid.title}</h5>
              <div className="row" key={index}>
                {grid.grid.map((item, index) => (
                  <div className={grid.classNameChild} key={index}>{item.element}</div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default GridSection;
